var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_788_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9996 1.71436H11.9996C6.31895 1.71436 1.71387 6.31944 1.71387 12.0001V36.0001C1.71387 41.6809 6.31895 46.2858 11.9996 46.2858H35.9996C41.6804 46.2858 46.2853 41.6809 46.2853 36.0001V12.0001C46.2853 6.31944 41.6804 1.71436 35.9996 1.71436Z",
    fill: "#008255",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9996 1.71436H11.9996C6.31895 1.71436 1.71387 6.31944 1.71387 12.0001V36.0001C1.71387 41.6809 6.31895 46.2858 11.9996 46.2858H35.9996C41.6804 46.2858 46.2853 41.6809 46.2853 36.0001V12.0001C46.2853 6.31944 41.6804 1.71436 35.9996 1.71436Z",
    stroke: "#008255",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0011 16.2856L20.2868 33.4285L13.4297 28.2856",
    stroke: "#008255",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_788_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.070de5afe66a50d1a3bc37f949ad9293.svg";
export { ForwardRef as ReactComponent };